<template>
  <div>

  <!-- Titulos -->
  <b-row>
    <b-col>
      <h5 class="bg-light m-0 mb-3 p-2"><strong>Configuración de etiquetas</strong></h5>
    </b-col>
  </b-row>

  <b-form @submit.prevent="onHandleStore" class="shadow-sm p-3 bg-white rounded" data-vv-scope="form-labels-messages">

    <!-- Contenido -->
    <b-row>

      <b-col sm="12" md="6" lg="6">

        <!-- Mensaje de etiqueta -->
        <div>

            <!-- Asignar País -->
            <label><h5 class="font-weight-bold">Mensaje de etiqueta</h5></label>
            <b-form-group>
                <label for="slq_country_id">Asignar País <span v-if="selectedMensaje.mensajeet" class="text-danger">(*)</span></label><br />

                <el-select @change="onHandleChangeCountry" id="slq_country_id" name="slq_country_id" v-model="selectedMensaje.slq_country_id" size="sm" clearable
                    v-validate="selectedMensaje.mensajeet ? 'required' : ''"
                    data-vv-as=" "
                >
                <el-option
                    v-for="countryCompany in getCompanyCountriesConfig"
                    :label="getLabelToSelect(countryCompany)"
                    :value="countryCompany.slq_country_id"
                    :key="countryCompany.slq_country_id"
                />
                </el-select>
                <span
                    class="text-danger span-error small"
                    v-text="errors.first('form-labels-messages.slq_country_id')"
                />
            </b-form-group>
        
            <!-- mensaje de emergencia para la etiqueta -->
            <b-form-group>
                <label for="emergency_message">Mensaje de emergencia para la etiqueta</label><br />
                <b-textarea style="height:110px;border:1px solid grey;"
                            class="form-control"
                            name="emergency_message"
                            v-model="selectedMensaje.mensajeet"
                            placeholder="Digite el mensaje de emergencia para la etiqueta..."
                />
            </b-form-group>
        </div>

        <!-- Configuración de teléfonos -->
        <div class="d-block mt-3">
          <h5 class="font-weight-bold">Configuración de teléfonos</h5>

          <!-- Configuración de países -->
          <div class="d-flex justify-content-start align-items-center">
            <div class="w-100 flex-1">
              <SelectConfigVars
                ref="selectConfigVarsRef"
                :companyId="selectedEmpresa.id"
                :useTitle="false"
              />
            </div>
            <b-button
              v-if="validarPermisoComponente('empresa-editar-etiquetas')"
              class="ml-2 mb-1 d-flex align-items-center"
              variant="primary"
              size="sm"
              @click="seletedConfigurableVar"
              :disabled="loading"
              :class="{'opacity-50': loading}"
            >
              <i class="fa fa-plus-circle mr-1" />
              Asignar
            </b-button>
          </div>

          <!-- Teléfonos seleccionados -->
          <br />
          <div v-for="item of configVarCompany" :key="item.id"
            class="d-flex justify-content-between align-items-center shadow-sm pr-4 bg-white rounded mb-2">
            <div class="item-phone-car-config-listed pl-4 py-2">
              <strong>{{ item.company_country.phone_code || '' }} {{ item.company_country.phone }}</strong>
              <div class="d-flex align-items-center">
                <span class="text-small">                
                    {{ item.company_country && 'country' in item.company_country ? '' : `${item.company_country.country.name} ${item.company_country.country.code || ''}`  }}                
                </span>
                <span class="ml-1 badge badge-custom text-white">{{ item.company_country.languague.lista || 'Español' }}</span>
              </div>
            </div>
            <i v-if="validarPermisoComponente('empresa-editar-etiquetas')" title="Eliminar registro"
              class="fa fa-trash text-danger p-1 rounded-xl cursor-pointer bg-gray-100"
              @click="deletePhone(item)"
            />
          </div>
          <div v-if="configVarCompany.length <= 0" class="d-flex justify-content-center align-items-center p-5 bg-gray-100">
            <i class="fa fa-info-circle" />
            <span class="text-small ml-2 mb-1">No hay teléfonos asignados.</span>
          </div>

        </div>

      </b-col>

      <b-col sm="12" md="6" lg="6">

        <!-- Vista previa -->
        <div v-if="selectedMensaje.mensajeet || configVarCompany.length > 0" class="d-flex">
          <div class="preview-content-message-label shadow-sm">
          <div class="preview-content-message-label-child">Vista previa</div>
        </div>

        <div v-if="selectedMensaje.mensajeet || configVarCompany.length > 0" class="shadow-sm preview-content-message d-flex justify-content-center align-items-center height-previewer shadow-sm p-3 bg-white rounded w-100">
          <div>
            <div v-if="configVarCompany.length <= 0">
              <p>{{ selectedMensaje.mensajeet }} </p>
            </div>
            <span v-for="(item, index) of configVarCompany" :key="item.id">
              <span v-if="index === 0">{{ selectedMensaje.mensajeet }} </span>
              {{ item.company_country.phone_code || '' }} {{ item.company_country.phone }} 
              {{ item.company_country && 'country' in item.company_country ? '' : `${item.company_country.country.name} ${item.company_country.country.code || ''}`  }}   
              <span v-if="(index + 1) < configVarCompany.length" class="mx-1">/</span>
            </span>
          </div>
          <div class="content-info-preview-text">
            <i class="fa fa-info-circle" />
            <i class="text-system text-small ml-2 mb-1">Mensaje para el pie de página en etiquetas.</i>
          </div>
        </div>
        </div>

        <!-- Medias de las etiquetas -->
        <div>
          <br />
          <h5>Medidas para las etiquetas</h5>
          <table class="table table-sm table-hover shadow-sm rounded ">
            <thead>
            <tr class="bg-gray-100">
              <th width="70%">Etiquetas</th>
              <th width="30%">Tamaño de la letra</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <!--<td>Medida 5x6,5x7cm</td>-->
              <td>ET Pequeña</td>
              <td>
                <b-form-select class="form-control"
                                v-model="selectedMensaje.medida4x6"
                                :options="medidas"
                />
              </td>
            </tr>
            <tr>
              <!--<td>Medida 7x10,7x12cm</td>-->
              <td>ET Mediana</td>
              <td>
                <b-form-select class="form-control"
                                v-model="selectedMensaje.medida7x10"
                                :options="medidas"
                />
              </td>
            </tr>
            <tr>
              <!--<td>Medida 18x10,18x12cm</td>-->
              <td>ET Grande</td>
              <td>
                <b-form-select class="form-control"
                                v-model="selectedMensaje.medida18x10"
                                :options="medidas"
                />
              </td>
            </tr>
            <tr>
              <!-- <td>Medida 21x18,22x18cm</td> -->
              <td>ET Extra-Grande</td>
              <td>
                <b-form-select class="form-control"
                                v-model="selectedMensaje.medida21x18"
                                :options="medidas"
                />
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </b-col>
    </b-row>

    <!-- Botones del footer -->
    <b-row>
      <hr>
      <b-col class="d-flex justify-content-between mt-4">
        <b-button @click="backRoute()" variant="secondary">
          <i class="fa fa-reply fa-lg"></i>
          Volver
        </b-button>
        <b-button v-if="validarPermisoComponente('empresa-editar-etiquetas')" variant="primary" type="submit">
          <i class="fa fa-save"></i>
          Guardar
        </b-button>
      </b-col>
    </b-row>

  </b-form>
  </div>
</template>

<script>

// Importaciones generales
import { mapState, mapActions, mapMutations } from 'vuex';

// Componentes
import Swal from 'sweetalert2';
import SelectConfigVars from './ConfigurableVariables/selectConfigVars.vue';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
  name: 'Etiquetas-mensaje-medidas',
  components: {
    SelectConfigVars,
  },
  data() {
    return {
      loading: false,
      validarPermisoComponente: validarPermisoComponente,
    }
  },
  computed: {
    ...mapState('empresa', ['medidas', 'selectedMensaje', 'selectedEmpresa', 'configVarCompany', 'messageLabels']),
    // Estados del modulo Configuración de países
    ...mapState('configurableVariables', ['configurableVariables']),

    getCompanyCountriesConfig() {
        try {

            if (this.configurableVariables && 'data' in this.configurableVariables && typeof this.configurableVariables.data ==='object') {
                return this.configurableVariables.data
            }

            return this.configurableVariables

        }  catch (e) {
            return []
        }
    }

  },
  async mounted() {
    await this.getMensaje(this.$route.params.id);
    await this.getOnlyCompany(this.selectedEmpresa.id);
    await this.onHandleLoadMessageLabels()
  },
  methods: {
    ...mapActions('empresa', [
      'guardaMensaje',
      'getMensaje',
      'storeCompanyCountryUser',
      'getOnlyCompany',
      'changeStatusCompanyConfigVar',
      'getAllMessageLabels'
    ]),
    ...mapMutations('empresa', [
      'resetMensaje',
      'setConfigVarCompany',
      'setSelectedMessage'
    ]),
    /**
     * Agregar el número de teléfono seleccionado a la lista de teléfonos.
     * @author Fernando Claros
     */
    seletedConfigurableVar() {

      const selectedItem = this.$refs.selectConfigVarsRef.model;

      if (!selectedItem) {
        Swal.fire({
          icon: "info",
          title: "Números de teléfono",
          text: "No has seleccionado un número de teléfono valido.",
          showConfirmButton: true
        })
        return false;
      }

      if (this.configVarCompany.find(x => x.slq_company_country_id == selectedItem)) {
        Swal.fire({
          icon: "info",
          title: "Números de teléfono",
          text: "El número ya ha sido asignado.",
          showConfirmButton: true
        })
        return false;
      }

      this.loading = true;

      // Guardar el número seleccionado
      const varConfig = this.configurableVariables.find(x => x.id == selectedItem);
      const payload = {
        companyId: this.selectedEmpresa.id,
        userId: 0,
        configVarId: selectedItem,
        id: varConfig.id
      }

      this.storeCompanyCountryUser(payload).then(async () => {

        this.$refs.selectConfigVarsRef.model = '';

        await this.getOnlyCompany(this.selectedEmpresa.id);
        this.loading = false;

      }).catch(() => this.loading = false);

    },
    /**
     * Eliminar el teléfono seleccionado de la lista de teléfonos.
     * @author Fernando Claros
     */
    deletePhone(varConfig) {

      if (!this.configVarCompany.find(x => x.id == varConfig.id)) {
        Swal.fire({
          icon: "error",
          title: "Números de teléfono",
          text: "El número no puede ser eliminado, por favor recarga y vuelve a intentar.",
          showConfirmButton: true
        })
        return false;
      }

      Swal.fire({
        title: "Números de teléfono",
        text: "¿Estas seguro que deseas eliminar este número.?",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {

        // Veririficar que la acción sea confirmada
        if (result.isConfirmed) {

          // Procesar a eiminar/cambiar estado del ítem
          this.changeStatusCompanyConfigVar({ companyId: this.selectedEmpresa.id, configVarId: varConfig.id })
            .then(async () => await this.getOnlyCompany(this.selectedEmpresa.id));

        }
      });

    },
    backRoute(){
        const currentPath = this.$route.path;
        if (currentPath.includes("/my-company")) {
            this.$router.go(-1);
        }else {
            this.$router.push("/empresas");
        }
    },

    getLabelToSelect(countryCompany) {
        try {
            return `${countryCompany && 'country' in countryCompany ? countryCompany.country.name + ' [' + countryCompany.country.code : ''}]`
        } catch (e) {
            return "";
        }
    },

    onHandleChangeCountry(currentCountry) {
        if (!this.messageLabels || typeof this.messageLabels !== 'object') return
        if (this.messageLabels.length > 0) this.setSelectedMessage({ ...this.selectedMensaje, mensajeet: '' });

        const messageLabel = this.messageLabels.find(x => x.slq_country_id === currentCountry)
        if (messageLabel) {
            this.setSelectedMessage({
                ...this.selectedMensaje,
                mensajeet: messageLabel.emergency_message,
                slq_country_id: messageLabel.slq_country_id
            });
        }

    },

    async onHandleLoadMessageLabels() {

        await this.getAllMessageLabels({ 
            params: { company_id: this.selectedEmpresa.id },
            callback: this.onHandleCallbackLoadMessageLabels
        });

    },

    async onHandleStore() {

        if (this.selectedMensaje.mensajeet && !this.selectedMensaje.slq_country_id) {
            this.$alertError("Para registrar el Mensaje de emergencia para la etiqueta, debes seleccionar un País. ", 4000, true, "Configuración de etiquetas", 'info');
            return 
        } 
        
        await this.guardaMensaje({ ...this.selectedMensaje, callback: this.onHandleCallbackStoreMessageLabels })
    
    },

    async onHandleCallbackStoreMessageLabels(status) {
        if (!status) return 

        await this.onHandleLoadMessageLabels()
    },

    onHandleCallbackLoadMessageLabels(status, response) {
        if (!status) return 

        const currentMessage = response.data && typeof response.data == 'object' && response.data.length > 0 ? response.data.reverse()[0] : null
        if (!currentMessage) return 

        this.setSelectedMessage({
            ...this.selectedMensaje,
            mensajeet: currentMessage.emergency_message,
            slq_country_id: currentMessage.slq_country_id
        });
    },

  },
};
</script>

<style scoped>

.height-previewer{
  min-height: 220px;
}

.preview-content-message-label {
  min-height: 220px;
  width: 35px;
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #097b83;
}

.preview-content-message-label-child {
  transform: rotate(-90deg);
  text-wrap: nowrap;
  text-transform: uppercase;
  font-weight: bold;
}

.preview-content-message{
  display: grid !important;
  grid-template-rows: 90% 10%;
}

.content-info-preview-text {
  min-height: 24px;
  padding: 0px 10px !important;
  width: 100%;
  justify-content: flex-end !important;
  display: flex !important;
  padding-top: 5px !important;
  align-items: center;
  color: #097b83;
}

.text-system {
  color: #097b83;
}

.item-phone-car-config-listed{
  border-left: 4px solid #097b83;
}

.badge-custom{
  background-color: #097b83;
}

</style>
